(function () {
  "use strict";

  // Jadore theme-hosted release; application API and form assets remain Portal-owned.
  var EMBED_ORIGIN = "https://portal.hadrill.com.au";

  /** Set to true only when testing: typing "ADMIN" in first name will prefill the form. */
  var SECRET_DEBUG_MODE = true;

  var FORM_FILES = {
    JADORE_WHOLESALE: "jadore_wholesale.html",
    HADRILL_WHOLESALE: "hadrill_wholesale.html",
  };

  /** Demo data for ADMIN prefill keyed by country (so prefill matches the country already set). */
  var DEMO_BY_COUNTRY = {
    Australia: {
      businessName: "Test Salon Pty Ltd",
      abn: "12 345 678 901",
      businessWebsite: "https://testsalon.com.au",
      instagramHandle: "@testsalon_au",
      businessType: "Salon Owner",
      country: "Australia",
      howDidYouHear: "Social media",
      howDidYouHearOther: "",
      firstName: "Test",
      lastName: "Admin",
      email: "herosignups+0@gmail.com",
      phone: "+61412345678",
      businessAddress: "123 George Street",
      city: "Sydney",
      state: "NSW",
      postcode: "2000",
      shippingSameAsBusiness: "yes",
      shippingAddress: "",
      shippingCity: "",
      shippingState: "",
      shippingPostcode: "",
      consentMarketingEmail: "yes",
      consentMarketingSms: "yes",
      consentTermsAndData: "yes",
    },
    "New Zealand": {
      businessName: "Test Salon NZ Ltd",
      abn: "12 345 678 901",
      businessWebsite: "https://testsalon.co.nz",
      instagramHandle: "@testsalon_nz",
      businessType: "Salon Owner",
      country: "New Zealand",
      howDidYouHear: "Social media",
      howDidYouHearOther: "",
      firstName: "Test",
      lastName: "Admin",
      email: "herosignups+0@gmail.com",
      phone: "+64212345678",
      businessAddress: "123 Queen Street",
      city: "Auckland",
      state: "Auckland",
      postcode: "1010",
      shippingSameAsBusiness: "yes",
      shippingAddress: "",
      shippingCity: "",
      shippingState: "",
      shippingPostcode: "",
      consentMarketingEmail: "yes",
      consentMarketingSms: "yes",
      consentTermsAndData: "yes",
    },
    "United Kingdom": {
      businessName: "Test Salon Ltd",
      taxNumber: "GB123456789",
      businessWebsite: "https://testsalon.co.uk",
      instagramHandle: "@testsalon_uk",
      businessType: "Salon Owner",
      country: "United Kingdom",
      howDidYouHear: "Social media",
      howDidYouHearOther: "",
      firstName: "Test",
      lastName: "Admin",
      email: "herosignups+0@gmail.com",
      phone: "+447400123456",
      businessAddress: "123 High Street",
      city: "London",
      state: "Greater London",
      postcode: "SW1A 1AA",
      shippingSameAsBusiness: "yes",
      shippingAddress: "",
      shippingCity: "",
      shippingState: "",
      shippingPostcode: "",
      consentMarketingEmail: "yes",
      consentMarketingSms: "yes",
      consentTermsAndData: "yes",
    },
    "United States": {
      businessName: "Test Salon LLC",
      taxNumber: "12-3456789",
      businessWebsite: "https://testsalon.com",
      instagramHandle: "@testsalon_us",
      businessType: "Salon Owner",
      country: "United States",
      howDidYouHear: "Social media",
      howDidYouHearOther: "",
      firstName: "Test",
      lastName: "Admin",
      email: "herosignups+0@gmail.com",
      phone: "+12025551234",
      businessAddress: "123 Main Street",
      city: "New York",
      state: "NY",
      postcode: "10001",
      shippingSameAsBusiness: "yes",
      shippingAddress: "",
      shippingCity: "",
      shippingState: "",
      shippingPostcode: "",
      consentMarketingEmail: "yes",
      consentMarketingSms: "yes",
      consentTermsAndData: "yes",
    },
    Canada: {
      businessName: "Test Salon Inc",
      taxNumber: "123456789RT0001",
      businessWebsite: "https://testsalon.ca",
      instagramHandle: "@testsalon_ca",
      businessType: "Salon Owner",
      country: "Canada",
      howDidYouHear: "Social media",
      howDidYouHearOther: "",
      firstName: "Test",
      lastName: "Admin",
      email: "herosignups+0@gmail.com",
      phone: "+14165551234",
      businessAddress: "123 King Street West",
      city: "Toronto",
      state: "ON",
      postcode: "M5V 1K4",
      shippingSameAsBusiness: "yes",
      shippingAddress: "",
      shippingCity: "",
      shippingState: "",
      shippingPostcode: "",
      consentMarketingEmail: "yes",
      consentMarketingSms: "yes",
      consentTermsAndData: "yes",
    },
    Ireland: {
      businessName: "Test Salon Ireland Ltd",
      taxNumber: "IE1234567T",
      businessWebsite: "https://testsalon.ie",
      instagramHandle: "@testsalon_ie",
      businessType: "Salon Owner",
      country: "Ireland",
      howDidYouHear: "Social media",
      howDidYouHearOther: "",
      firstName: "Test",
      lastName: "Admin",
      email: "herosignups+0@gmail.com",
      phone: "+353851234567",
      businessAddress: "123 O'Connell Street",
      city: "Dublin",
      state: "Dublin",
      postcode: "D01 F5P2",
      shippingSameAsBusiness: "yes",
      shippingAddress: "",
      shippingCity: "",
      shippingState: "",
      shippingPostcode: "",
      consentMarketingEmail: "yes",
      consentMarketingSms: "yes",
      consentTermsAndData: "yes",
    },
    France: {
      businessName: "Test Salon SARL",
      taxNumber: "FR12345678901",
      businessWebsite: "https://testsalon.fr",
      instagramHandle: "@testsalon_fr",
      businessType: "Salon Owner",
      country: "France",
      howDidYouHear: "Social media",
      howDidYouHearOther: "",
      firstName: "Test",
      lastName: "Admin",
      email: "herosignups+0@gmail.com",
      phone: "+33612345678",
      businessAddress: "123 Rue de Rivoli",
      city: "Paris",
      state: "Île-de-France",
      postcode: "75001",
      shippingSameAsBusiness: "yes",
      shippingAddress: "",
      shippingCity: "",
      shippingState: "",
      shippingPostcode: "",
      consentMarketingEmail: "yes",
      consentMarketingSms: "yes",
      consentTermsAndData: "yes",
    },
    Germany: {
      businessName: "Test Salon GmbH",
      taxNumber: "DE123456789",
      businessWebsite: "https://testsalon.de",
      instagramHandle: "@testsalon_de",
      businessType: "Salon Owner",
      country: "Germany",
      howDidYouHear: "Social media",
      howDidYouHearOther: "",
      firstName: "Test",
      lastName: "Admin",
      email: "herosignups+0@gmail.com",
      phone: "+491711234567",
      businessAddress: "123 Friedrichstraße",
      city: "Berlin",
      state: "Berlin",
      postcode: "10117",
      shippingSameAsBusiness: "yes",
      shippingAddress: "",
      shippingCity: "",
      shippingState: "",
      shippingPostcode: "",
      consentMarketingEmail: "yes",
      consentMarketingSms: "yes",
      consentTermsAndData: "yes",
    },
    Spain: {
      businessName: "Test Salon SL",
      taxNumber: "ES12345678A",
      businessWebsite: "https://testsalon.es",
      instagramHandle: "@testsalon_es",
      businessType: "Salon Owner",
      country: "Spain",
      howDidYouHear: "Social media",
      howDidYouHearOther: "",
      firstName: "Test",
      lastName: "Admin",
      email: "herosignups+0@gmail.com",
      phone: "+34612345678",
      businessAddress: "123 Gran Vía",
      city: "Madrid",
      state: "Madrid",
      postcode: "28013",
      shippingSameAsBusiness: "yes",
      shippingAddress: "",
      shippingCity: "",
      shippingState: "",
      shippingPostcode: "",
      consentMarketingEmail: "yes",
      consentMarketingSms: "yes",
      consentTermsAndData: "yes",
    },
    Italy: {
      businessName: "Test Salon SRL",
      taxNumber: "IT12345678901",
      businessWebsite: "https://testsalon.it",
      instagramHandle: "@testsalon_it",
      businessType: "Salon Owner",
      country: "Italy",
      howDidYouHear: "Social media",
      howDidYouHearOther: "",
      firstName: "Test",
      lastName: "Admin",
      email: "herosignups+0@gmail.com",
      phone: "+393121234567",
      businessAddress: "123 Via Roma",
      city: "Milan",
      state: "Lombardy",
      postcode: "20121",
      shippingSameAsBusiness: "yes",
      shippingAddress: "",
      shippingCity: "",
      shippingState: "",
      shippingPostcode: "",
      consentMarketingEmail: "yes",
      consentMarketingSms: "yes",
      consentTermsAndData: "yes",
    },
    Netherlands: {
      businessName: "Test Salon BV",
      taxNumber: "NL123456789B01",
      businessWebsite: "https://testsalon.nl",
      instagramHandle: "@testsalon_nl",
      businessType: "Salon Owner",
      country: "Netherlands",
      howDidYouHear: "Social media",
      howDidYouHearOther: "",
      firstName: "Test",
      lastName: "Admin",
      email: "herosignups+0@gmail.com",
      phone: "+31612345678",
      businessAddress: "123 Damrak",
      city: "Amsterdam",
      state: "North Holland",
      postcode: "1012 LG",
      shippingSameAsBusiness: "yes",
      shippingAddress: "",
      shippingCity: "",
      shippingState: "",
      shippingPostcode: "",
      consentMarketingEmail: "yes",
      consentMarketingSms: "yes",
      consentTermsAndData: "yes",
    },
    Belgium: {
      businessName: "Test Salon BVBA",
      taxNumber: "BE0123456789",
      businessWebsite: "https://testsalon.be",
      instagramHandle: "@testsalon_be",
      businessType: "Salon Owner",
      country: "Belgium",
      howDidYouHear: "Social media",
      howDidYouHearOther: "",
      firstName: "Test",
      lastName: "Admin",
      email: "herosignups+0@gmail.com",
      phone: "+32470123456",
      businessAddress: "123 Grand Place",
      city: "Brussels",
      state: "Brussels",
      postcode: "1000",
      shippingSameAsBusiness: "yes",
      shippingAddress: "",
      shippingCity: "",
      shippingState: "",
      shippingPostcode: "",
      consentMarketingEmail: "yes",
      consentMarketingSms: "yes",
      consentTermsAndData: "yes",
    },
    "Other EU": {
      businessName: "Test Salon EU",
      taxNumber: "DE123456789",
      businessWebsite: "https://testsalon.eu",
      instagramHandle: "@testsalon_eu",
      businessType: "Salon Owner",
      country: "Other EU",
      howDidYouHear: "Social media",
      howDidYouHearOther: "",
      firstName: "Test",
      lastName: "Admin",
      email: "herosignups+0@gmail.com",
      phone: "+491711234567",
      businessAddress: "123 International Street",
      city: "Berlin",
      state: "Berlin",
      postcode: "10117",
      shippingSameAsBusiness: "yes",
      shippingAddress: "",
      shippingCity: "",
      shippingState: "",
      shippingPostcode: "",
      consentMarketingEmail: "yes",
      consentMarketingSms: "yes",
      consentTermsAndData: "yes",
    },
  };

  /** Fallback prefill when no demo for current country (Jadore → Australia, Hadrill → UK). */
  var JADORE_PREFILL = DEMO_BY_COUNTRY.Australia;
  var HADRILL_PREFILL = DEMO_BY_COUNTRY["United Kingdom"];

  /** Country → phone format: code (E.164), expected digit count, placeholder, label for UI */
  var COUNTRY_PHONE_CONFIG = {
    Australia: { code: "61", digits: 9, placeholder: "412 345 678", label: "Australia" },
    "New Zealand": { code: "64", digits: 9, placeholder: "21 234 5678", label: "New Zealand" },
    "United Kingdom": { code: "44", digits: 10, placeholder: "7400 123456", label: "UK" },
    "United States": { code: "1", digits: 10, placeholder: "202 555 1234", label: "US" },
    Canada: { code: "1", digits: 10, placeholder: "416 555 1234", label: "Canada" },
    Ireland: { code: "353", digits: 9, placeholder: "85 123 4567", label: "Ireland" },
    France: { code: "33", digits: 9, placeholder: "6 12 34 56 78", label: "France" },
    Germany: { code: "49", digits: 10, placeholder: "171 1234567", label: "Germany" },
    Spain: { code: "34", digits: 9, placeholder: "612 34 56 78", label: "Spain" },
    Italy: { code: "39", digits: 10, placeholder: "312 345 6789", label: "Italy" },
    Netherlands: { code: "31", digits: 9, placeholder: "6 12345678", label: "Netherlands" },
    Belgium: { code: "32", digits: 9, placeholder: "470 12 34 56", label: "Belgium" },
    "Other EU": { code: null, digits: null, placeholder: "e.g. +49 171 1234567", label: "International" },
  };

  function getApiBase() {
    if (EMBED_ORIGIN) return EMBED_ORIGIN;
    var script = document.currentScript;
    if (script && script.src) try { return new URL(script.src).origin; } catch (e) {}
    return "https://portal.hadrill.com.au";
  }

  function injectCss(apiBase) {
    var href = apiBase + "/embed/wholesale.css";
    if (document.querySelector('link[href="' + href + '"]')) return;
    var link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    document.head.appendChild(link);
  }

  function formToPayload(form, formId) {
    var payload = { formId: formId };
    var els = form.querySelectorAll("[name]");
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var name = el.getAttribute("name");
      if (!name) continue;
      if (el.type === "radio" || el.type === "checkbox") {
        if (el.checked) payload[name] = el.value;
      } else {
        payload[name] = el.value;
      }
    }
    payload.shippingSameAsBusiness = payload.shippingSameAsBusiness === "yes";
    payload.consentMarketingEmail = payload.consentMarketingEmail === "yes";
    payload.consentMarketingSms = payload.consentMarketingSms === "yes";
    payload.consentTermsAndData = payload.consentTermsAndData === "yes";
    return payload;
  }

  function clearFieldErrors(form) {
    form.querySelectorAll(".whemb-field-error").forEach(function (el) {
      el.remove();
    });
    form.querySelectorAll("[data-whemb-field] input, [data-whemb-field] select").forEach(function (el) {
      el.removeAttribute("aria-invalid");
    });
  }

  function showFieldErrors(form, fields) {
    if (!fields || typeof fields !== "object") return;
    var firstInvalid = null;
    for (var name in fields) {
      if (!fields.hasOwnProperty(name)) continue;
      var msg = fields[name];
      if (!msg) continue;
      var input = form.querySelector('[name="' + name + '"]');
      if (!input) continue;
      var field = input.closest("[data-whemb-field]");
      if (!field) continue;
      var existing = field.querySelector(".whemb-field-error");
      if (existing) existing.remove();
      var span = document.createElement("span");
      span.className = "whemb-field-error";
      span.setAttribute("role", "alert");
      span.textContent = msg;
      field.appendChild(span);
      input.setAttribute("aria-invalid", "true");
      if (!firstInvalid) firstInvalid = input;
    }
    if (firstInvalid) {
      firstInvalid.focus();
      firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  /**
   * Client-side validation: required fields, dropdowns selected, consent checkbox.
   * Returns { ok: true } or { ok: false, fields: { name: message } }.
   */
  function validateForm(form) {
    var fields = {};
    var shippingSame = form.querySelector('[name="shippingSameAsBusiness"]');
    var shippingSameVal = shippingSame ? (shippingSame.value || "").toLowerCase() : "yes";
    var requireShipping = shippingSameVal === "no";

    function add(name, msg) {
      if (name && msg) fields[name] = msg;
    }

    form.querySelectorAll("[name]").forEach(function (el) {
      var name = el.getAttribute("name");
      if (!name) return;
      if (el.type === "checkbox" || el.type === "radio") {
        if (el.hasAttribute("required") && !el.checked) {
          if (name === "consentTermsAndData") add(name, "You must agree to the Terms & Conditions and data processing notice to submit.");
          else add(name, "This field is required.");
        }
        return;
      }
      if (el.tagName === "SELECT") {
        var val = (el.value || "").trim();
        if (el.hasAttribute("required") && val === "") add(name, "Please select an option.");
        return;
      }
      if (el.type === "text" || el.type === "email" || el.type === "tel" || !el.type) {
        var required = el.hasAttribute("required");
        var isShipping = name === "shippingAddress" || name === "shippingCity" || name === "shippingState" || name === "shippingPostcode";
        var isHearOther = name === "howDidYouHearOther";
        if (isShipping && !requireShipping) return;
        if (isHearOther) return;
        var empty = (el.value || "").trim() === "";
        if (required && empty) add(name, "This field is required.");
        if (isShipping && requireShipping && empty) add(name, "This field is required when shipping address differs.");
        var maxLen = el.getAttribute("maxlength");
        if (maxLen) {
          var max = parseInt(maxLen, 10);
          if (!isNaN(max) && (el.value || "").length > max) {
            add(name, "Must be at most " + max + " characters.");
          }
        }
      }
    });

    var howDidYouHear = form.querySelector('[name="howDidYouHear"]');
    var howDidYouHearOther = form.querySelector('[name="howDidYouHearOther"]');
    if (howDidYouHear && howDidYouHearOther) {
      if ((howDidYouHear.value || "").trim() === "Other" && (howDidYouHearOther.value || "").trim() === "") {
        add("howDidYouHearOther", "Please specify how you heard about us.");
      }
    }

    var countrySelect = form.querySelector('[name="country"]');
    var country = countrySelect ? (countrySelect.value || "").trim() : "";
    var phoneEl = form.querySelector('[name="phone"]');
    var phoneVal = phoneEl ? (phoneEl.value || "").trim() : "";
    var cfg = country ? COUNTRY_PHONE_CONFIG[country] : null;
    if (cfg && cfg.code !== null && cfg.digits !== null) {
      if (!phoneVal) {
        add("phone", "Enter a valid " + (cfg.label || country) + " phone number.");
      } else {
        var digitsOnly = phoneVal.replace(/\D/g, "");
        var national = digitsOnly.indexOf(cfg.code) === 0 ? digitsOnly.slice(cfg.code.length) : digitsOnly;
        if (national.charAt(0) === "0" && national.length === cfg.digits + 1) national = national.slice(1);
        if (national.length !== cfg.digits) {
          add("phone", "Enter exactly " + cfg.digits + " digits for " + (cfg.label || country) + " (leading 0 optional).");
        }
      }
    } else if (cfg && cfg.code === null && phoneVal) {
      var len = phoneVal.replace(/\D/g, "").length;
      if (len < 10 || len > 14) add("phone", "Enter a valid international number (10–14 digits).");
    }

    var bizAddr2 = form.querySelector('[name="businessAddress2"]');
    if (bizAddr2) {
      var addrLineMax = 45;
      var bizStreet = (form.querySelector('[name="businessAddress"]') || {}).value || "";
      var bizUnit = (bizAddr2.value || "").trim();
      if ((bizStreet.length + bizUnit.length) > addrLineMax) {
        add("businessAddress", "Street + Unit/Suite must be " + addrLineMax + " characters total. You have " + (bizStreet.length + bizUnit.length) + ".");
      }
      if (requireShipping) {
        var shipStreet = (form.querySelector('[name="shippingAddress"]') || {}).value || "";
        var shipUnit = (form.querySelector('[name="shippingAddress2"]') || {}).value || "";
        if ((shipStreet.length + shipUnit.length) > addrLineMax) {
          add("shippingAddress", "Street + Unit/Suite must be " + addrLineMax + " characters total. You have " + (shipStreet.length + shipUnit.length) + ".");
        }
      }
    }

    if (Object.keys(fields).length > 0) return { ok: false, fields: fields };
    return { ok: true };
  }

  function setupPhoneByCountry(form, formId) {
    var countrySelect = form.querySelector('[name="country"]');
    var phoneWrap = form.querySelector("[data-whemb-phone-wrap]");
    var phonePrefix = form.querySelector("[data-whemb-phone-prefix]");
    var phoneNational = form.querySelector("[data-whemb-phone-national]");
    var phoneHidden = form.querySelector('[name="phone"]');
    var phoneLabel = form.querySelector("[data-whemb-phone-label]");
    var phoneHint = form.querySelector("[data-whemb-phone-hint]");
    if (!countrySelect || !phoneWrap || !phoneHidden) return;

    var isUKHadrill = formId === "HADRILL_WHOLESALE";
    var uk07Hint = null;
    if (isUKHadrill) {
      uk07Hint = document.createElement("p");
      uk07Hint.setAttribute("data-whemb-phone-uk-07-hint", "");
      uk07Hint.className = "mt-1.5 text-xs text-amber-600";
      uk07Hint.textContent = "You don't need the leading 0 — we add +44 for you. Remove the 0 to avoid errors.";
      uk07Hint.hidden = true;
      if (phoneHint && phoneHint.parentNode) phoneHint.parentNode.insertBefore(uk07Hint, phoneHint.nextSibling);
      else phoneWrap.appendChild(uk07Hint);
    }

    function updateUk07Hint() {
      if (!uk07Hint || !phoneNational) return;
      var country = (countrySelect.value || "").trim();
      var raw = (phoneNational.value || "").replace(/\D/g, "");
      var show = country === "United Kingdom" && raw.length >= 2 && raw.indexOf("07") === 0;
      uk07Hint.hidden = !show;
    }

    function clearPhoneError() {
      var err = phoneWrap.querySelector(".whemb-field-error");
      if (err) err.remove();
      if (phoneNational) phoneNational.removeAttribute("aria-invalid");
    }

    function updatePhoneForCountry() {
      var country = (countrySelect.value || "").trim();
      var cfg = COUNTRY_PHONE_CONFIG[country];
      clearPhoneError();
      if (!cfg) {
        phoneWrap.classList.add("hidden");
        phoneWrap.hidden = true;
        if (phoneNational) phoneNational.value = "";
        phoneHidden.value = "";
        updateUk07Hint();
        return;
      }
      phoneWrap.classList.remove("hidden");
      phoneWrap.hidden = false;
      if (phoneLabel) phoneLabel.textContent = "(" + cfg.label + ")";
      if (cfg.code !== null && cfg.digits !== null) {
        if (phoneHint) phoneHint.textContent = "Enter " + cfg.digits + " digits (you can include a leading 0). No spaces or country code.";
        if (phonePrefix) {
          phonePrefix.textContent = "+" + cfg.code + " ";
          phonePrefix.style.display = "";
        }
        if (phoneNational) {
          phoneNational.placeholder = cfg.placeholder;
          // Allow a leading 0 (common local format). We'll drop it when building the +country E.164 value.
          phoneNational.maxLength = cfg.digits + 1;
          phoneNational.value = "";
          phoneNational.setAttribute("inputmode", "numeric");
        }
        phoneHidden.value = "";
      } else {
        if (phonePrefix) phonePrefix.style.display = "none";
        if (phoneNational) {
          phoneNational.placeholder = cfg.placeholder;
          phoneNational.removeAttribute("maxLength");
          phoneNational.value = "";
        }
        if (phoneHint) phoneHint.textContent = "Enter 10–14 digits only (e.g. 491711234567). We'll add the + for you.";
        phoneHidden.value = "";
      }
      updateUk07Hint();
    }

    function syncHiddenFromNational() {
      var country = (countrySelect.value || "").trim();
      var cfg = COUNTRY_PHONE_CONFIG[country];
      var raw = (phoneNational && phoneNational.value) ? phoneNational.value : "";
      var digits = raw.replace(/\D/g, "");
      if (cfg && cfg.code !== null && cfg.digits !== null) {
        var codeDigits = cfg.code.replace(/\D/g, "");
        if (digits.indexOf(codeDigits) === 0) digits = digits.slice(codeDigits.length);
        var normalized = digits;
        if (normalized.charAt(0) === "0" && normalized.length === cfg.digits + 1) normalized = normalized.slice(1);
        if (normalized.length > cfg.digits) normalized = normalized.slice(0, cfg.digits);
        phoneHidden.value = normalized.length === cfg.digits ? "+" + cfg.code + normalized : "";
      } else {
        phoneHidden.value = digits.length >= 10 ? "+" + digits : "";
      }
      clearPhoneError();
      updateUk07Hint();
    }

    if (phoneNational) {
      phoneNational.addEventListener("input", function () {
        var country = (countrySelect.value || "").trim();
        var cfg = COUNTRY_PHONE_CONFIG[country];
        var digits = this.value.replace(/\D/g, "");
        if (cfg && cfg.code !== null && cfg.digits !== null) {
          this.value = digits.slice(0, cfg.digits + 1);
        } else {
          this.value = digits.slice(0, 14);
        }
        syncHiddenFromNational();
        updateUk07Hint();
      });
      phoneNational.addEventListener("blur", function () {
        var country = (countrySelect.value || "").trim();
        var cfg = COUNTRY_PHONE_CONFIG[country];
        var digits = this.value.replace(/\D/g, "");
        if (digits.length === 0) return;
        if (cfg && cfg.code !== null && cfg.digits !== null) {
          var normalized = digits;
          if (normalized.charAt(0) === "0" && normalized.length === cfg.digits + 1) normalized = normalized.slice(1);
          if (normalized.length > cfg.digits) normalized = normalized.slice(0, cfg.digits);
          if (normalized.length === cfg.digits) return;
          var err = phoneWrap.querySelector(".whemb-field-error");
          if (!err) {
            err = document.createElement("span");
            err.className = "whemb-field-error";
            err.setAttribute("role", "alert");
            phoneWrap.appendChild(err);
          }
          err.textContent = "Enter " + cfg.digits + " digits for " + (cfg.label || country) + " (leading 0 is optional).";
          this.setAttribute("aria-invalid", "true");
        }
      });
    }

    countrySelect.addEventListener("change", function () {
      updatePhoneForCountry();
    });
    updatePhoneForCountry();
  }

  function applyPrefill(form, formId, prefill) {
    if (!prefill || typeof prefill !== "object") return;
    var countrySelect = form.querySelector('[name="country"]');
    if (countrySelect && prefill.country) {
      countrySelect.value = prefill.country;
      countrySelect.dispatchEvent(new Event("change", { bubbles: true }));
    }
    var phoneVal = prefill.phone;
    for (var name in prefill) {
      if (!prefill.hasOwnProperty(name)) continue;
      var val = prefill[name];
      var input = form.querySelector('[name="' + name + '"]');
      if (!input) continue;
      if (input.type === "checkbox" || input.type === "radio") {
        input.checked = val === "yes" || val === true;
      } else if (input.tagName === "SELECT") {
        input.value = val || "";
      } else if (name === "phone") {
        input.value = val || "";
      } else {
        input.value = val == null ? "" : String(val);
      }
    }
    if (phoneVal) {
      setTimeout(function () {
        var phoneHidden = form.querySelector('[name="phone"]');
        var nationalInput = form.querySelector("[data-whemb-phone-national]");
        if (phoneHidden) phoneHidden.value = phoneVal;
        if (nationalInput) {
          var digits = String(phoneVal).replace(/\D/g, "");
          var country = countrySelect ? countrySelect.value : "";
          var cfg = COUNTRY_PHONE_CONFIG[country];
          if (cfg && cfg.code) {
            var codeDigits = cfg.code.replace(/\D/g, "");
            if (digits.indexOf(codeDigits) === 0) digits = digits.slice(codeDigits.length);
          }
          nationalInput.value = digits;
        }
      }, 0);
    }
  }

  function fetchWithTimeout(url, ms) {
    var controller = new AbortController();
    var timeoutId = setTimeout(function () {
      controller.abort();
    }, ms);
    return fetch(url, { signal: controller.signal }).then(
      function (res) {
        clearTimeout(timeoutId);
        return res;
      },
      function (err) {
        clearTimeout(timeoutId);
        throw err;
      }
    );
  }

  var FORM_FETCH_TIMEOUT_MS = 12000;
  var FORM_FETCH_MAX_ATTEMPTS = 3;
  var FORM_FETCH_RETRY_DELAY_MS = 800;

  function mountForm(container, formId) {
    var fileName = FORM_FILES[formId];
    if (!fileName) return;

    var apiBase = getApiBase();
    if (!apiBase) return;

    injectCss(apiBase);

    var formUrl = apiBase + "/embed/" + fileName;
    var applicationVerificationToken = null;
    var submissionInFlight = false;
    var completionHandled = false;

    // Opt-in Jadore production success URL; no personal data in the destination.
    function getSuccessDestination() {
      if (formId !== "JADORE_WHOLESALE") return null;
      if (window.location.origin !== "https://trade.jadorehairsupplies.com.au") return null;
      var configured = container.getAttribute("data-success-url");
      if (!configured) return null;
      try {
        var destination = new URL(configured, window.location.origin);
        if (destination.origin !== window.location.origin || destination.username || destination.password) return null;
        if (destination.pathname !== "/pages/wholesale-application-received" || destination.search || destination.hash) return null;
        return destination.href;
      } catch (_) { return null; }
    }

    function showCodeStep(email) {
      try { window.scrollTo(0, 0); } catch (e) {}
      container.innerHTML =
        "<div class=\"whemb-email-step\" style=\"max-width:400px;margin-left:auto;margin-right:auto;padding:2rem 1.5rem;box-sizing:border-box;\">" +
        "<p style=\"font-size:0.875rem;color:#6b7280;margin-bottom:0.75rem;\">We've sent you an email with a code. Enter it below to finish your application.</p>" +
        "<label for=\"whemb-code-input\" style=\"display:block;font-size:1.125rem;font-weight:500;color:#111827;margin-bottom:0.5rem;\">Verification code</label>" +
        "<input type=\"text\" id=\"whemb-code-input\" data-whemb-code-input inputmode=\"numeric\" autocomplete=\"one-time-code\" placeholder=\"000000\" maxlength=\"6\" style=\"width:100%;border:1px solid #d1d5db;border-radius:0.5rem;padding:0.75rem 1rem;font-size:1.25rem;letter-spacing:0.2em;text-align:center;color:#111827;box-sizing:border-box;\">" +
        "<p data-whemb-code-msg style=\"margin-top:0.75rem;min-height:1.25rem;font-size:0.875rem;color:#6b7280;\"></p>" +
        "<button type=\"button\" data-whemb-code-continue style=\"margin-top:1rem;padding:0.75rem 1.5rem;border:1px solid #111827;background:#111827;color:#fff;border-radius:0.5rem;font-size:0.875rem;font-weight:500;cursor:pointer;\">Continue</button>" +
        "</div>";
      var input = container.querySelector("[data-whemb-code-input]");
      var btn = container.querySelector("[data-whemb-code-continue]");
      var msgEl = container.querySelector("[data-whemb-code-msg]");
      function setMsg(text, isError) {
        msgEl.textContent = text || "";
        msgEl.className = "mt-3 min-h-5 text-sm " + (isError ? "text-red-600" : "text-gray-500");
      }
      btn.addEventListener("click", function () {
        var code = (input.value || "").trim().replace(/\s/g, "");
        if (!code || code.length < 4) {
          setMsg("Please enter the 6-digit code from your email.", true);
          return;
        }
        btn.disabled = true;
        setMsg("Verifying…", false);
        fetch(apiBase + "/api/wholesale/verify-application-code", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: email, formId: formId, code: code }),
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data && data.ok && data.token) {
              applicationVerificationToken = data.token;
              loadFullForm(email);
            } else {
              setMsg(data && data.error ? data.error : "Invalid or expired code. Request a new one.", true);
              btn.disabled = false;
            }
          })
          .catch(function () {
            setMsg("Something went wrong. Please try again.", true);
            btn.disabled = false;
          });
      });
    }

    function showEmailStep() {
      container.innerHTML =
        "<div class=\"whemb-email-step\" style=\"max-width:400px;margin-left:auto;margin-right:auto;padding:2rem 1.5rem;box-sizing:border-box;\">" +
        "<label for=\"whemb-email-input\" style=\"display:block;font-size:1.125rem;font-weight:500;color:#111827;margin-bottom:0.5rem;\">What's your email?</label>" +
        "<input type=\"email\" id=\"whemb-email-input\" data-whemb-email-input autocomplete=\"email\" placeholder=\"you@example.com\" style=\"width:100%;border:1px solid #d1d5db;border-radius:0.5rem;padding:0.75rem 1rem;font-size:1rem;color:#111827;box-sizing:border-box;\">" +
        "<p data-whemb-email-msg style=\"margin-top:0.75rem;min-height:1.25rem;font-size:0.875rem;color:#6b7280;\"></p>" +
        "<button type=\"button\" data-whemb-email-continue style=\"margin-top:1rem;padding:0.75rem 1.5rem;padding-left:1.5rem;padding-right:1.5rem;border:1px solid #111827;background:#111827;color:#fff;border-radius:0.5rem;font-size:0.875rem;font-weight:500;cursor:pointer;\">Continue...</button>" +
        "</div>";
      var input = container.querySelector("[data-whemb-email-input]");
      var btn = container.querySelector("[data-whemb-email-continue]");
      var msgEl = container.querySelector("[data-whemb-email-msg]");
      function setMsg(text, isError) {
        msgEl.textContent = text || "";
        msgEl.className = "mt-3 min-h-5 text-sm " + (isError ? "text-red-600" : "text-gray-500");
      }
      btn.addEventListener("click", function () {
        var email = (input.value || "").trim().toLowerCase();
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          setMsg("Please enter a valid email address.", true);
          return;
        }
        btn.disabled = true;
        setMsg("Checking...", false);
        var checkUrl = apiBase + "/api/wholesale/check-existing-account?email=" + encodeURIComponent(email) + "&formId=" + encodeURIComponent(formId);
        fetch(checkUrl)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data && data.existing) {
              setMsg("Sending you a code…", false);
              fetch(apiBase + "/api/wholesale/send-application-code", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email: email, formId: formId }),
              })
                .then(function (r) { return r.json(); })
                .then(function (sendData) {
                  if (sendData && sendData.ok) {
                    showCodeStep(email);
                  } else {
                    setMsg(sendData && sendData.error ? sendData.error : "Could not send code. Please try again.", true);
                    btn.disabled = false;
                  }
                })
                .catch(function () {
                  setMsg("Something went wrong. Please try again.", true);
                  btn.disabled = false;
                });
            } else {
              loadFullForm(email);
            }
          })
          .catch(function () {
            setMsg("Something went wrong. Please try again.", true);
            btn.disabled = false;
          });
      });
    }

    function loadFullForm(prefillEmail) {
      attempt(0, false, prefillEmail);
    }

    function attempt(attemptNumber, singleAttempt, prefillEmail) {
      prefillEmail = typeof prefillEmail === "string" ? prefillEmail.trim() : "";
      fetchWithTimeout(formUrl, FORM_FETCH_TIMEOUT_MS)
        .then(function (res) {
          if (!res.ok) throw new Error("Form not found " + res.status);
          return res.text();
        })
        .then(function (html) {
          container.innerHTML = html;

          var form = container.querySelector("[data-whemb-form]");
          if (!form) {
            throw new Error("No [data-whemb-form] in response");
          }
          if (prefillEmail) {
            var emailInput = form.querySelector('[name="email"]');
            if (emailInput) emailInput.value = prefillEmail;
          }
          var msgEl = container.querySelector("[data-whemb-msg]");
        var submitBtn = form.querySelector('[type="submit"]');
        var shippingToggle = container.querySelector("[data-whemb-shipping-toggle]");
        var shippingBlock = container.querySelector("[data-whemb-shipping-block]");

        // Signup-page gate only: does not change accounts, checkout or shipping.
        var gateCountry = form.querySelector('[name="country"]');
        var finlandNotice = form.querySelector('[data-whemb-finland-notice]');
        var countryGateDisabled = false;
        function isFinlandSignup() {
          return formId === "HADRILL_WHOLESALE" && gateCountry && gateCountry.value === "Finland";
        }
        function updateFinlandGate() {
          var blocked = !!isFinlandSignup();
          if (finlandNotice) {
            finlandNotice.hidden = !blocked;
            finlandNotice.classList.toggle("hidden", !blocked);
          }
          if (submitBtn && blocked && !submitBtn.disabled) {
            submitBtn.disabled = true;
            countryGateDisabled = true;
          } else if (submitBtn && !blocked && countryGateDisabled) {
            submitBtn.disabled = false;
            countryGateDisabled = false;
          }
        }
        if (formId === "HADRILL_WHOLESALE" && gateCountry) {
          gateCountry.addEventListener("change", updateFinlandGate);
          updateFinlandGate();
        }

        function showMsg(text, isError) {
          msgEl.textContent = text;
          msgEl.className = "mt-4 min-h-5 text-sm " + (isError ? "text-red-600" : "text-emerald-600");
        }

        function completeSignup() {
          if (completionHandled) return;
          completionHandled = true;
          var signupEmail = (form.querySelector('[name="email"]') || {}).value || "";
          // Always leave a confirmation behind if navigation cannot complete.
          showThankYouScreen(signupEmail);
          var destination = getSuccessDestination();
          if (destination) {
            try { window.location.replace(destination); } catch (_) {}
          }
        }

        function showThankYouScreen(signupEmail) {
          try { window.scrollTo(0, 0); } catch (e) {}
          var email = (signupEmail || "").trim();
          var safeEmail = email.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
          var importantBlock = email
            ? "<p class=\"whemb-thanks-important\"><strong class=\"text-gray-900\">Important.</strong> You'll have to use the email <a href=\"mailto:" + safeEmail + "\" class=\"text-gray-900 underline font-medium\">" + safeEmail + "</a> to log in once your account is approved.</p>"
            : "";
          var communityName = formId === "JADORE_WHOLESALE" ? "Jadore" : "Hadrill";
          container.innerHTML =
            "<div class=\"whemb-thanks max-w-xl mx-auto py-12 px-6 text-center\">" +
            "<div class=\"whemb-thanks-icon mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-emerald-100\">" +
            "<svg class=\"h-9 w-9 text-emerald-600\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" stroke-width=\"2\">" +
            "<path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5 13l4 4L19 7\"/>" +
            "</svg></div>" +
            "<h2 class=\"text-2xl font-semibold tracking-tight text-gray-900 mb-2\">Thank you</h2>" +
            "<p class=\"text-lg text-gray-600 mb-6\">We've received your wholesale application.</p>" +
            "<div class=\"text-left space-y-4 text-sm text-gray-600 bg-gray-50 rounded-xl p-5 border border-gray-100\">" +
            "<p><strong class=\"text-gray-900\">What happens next?</strong></p>" +
            "<p>You'll receive an email from us within the <strong>next 30 minutes</strong> with confirmation and next steps.</p>" +
            "<p>We review applications quickly. Once approved, you'll be able to log in and place orders. Until then, you won't have access to the trade store. We appreciate your patience.</p>" +
            importantBlock +
            "<p class=\"text-gray-500\">If you don't see our email, check your spam folder or get in touch.</p>" +
            "<p class=\"whemb-thanks-welcome text-gray-700 mt-4\">We are so excited to welcome you to the " + communityName + " community.</p>" +
            "</div></div>";
        }

        function copyBusinessToShipping() {
          var businessAddress = form.querySelector('[name="businessAddress"]');
          var businessAddress2 = form.querySelector('[name="businessAddress2"]');
          var city = form.querySelector('[name="city"]');
          var state = form.querySelector('[name="state"]');
          var postcode = form.querySelector('[name="postcode"]');
          var shippingAddress = form.querySelector('[name="shippingAddress"]');
          var shippingAddress2 = form.querySelector('[name="shippingAddress2"]');
          var shippingCity = form.querySelector('[name="shippingCity"]');
          var shippingState = form.querySelector('[name="shippingState"]');
          var shippingPostcode = form.querySelector('[name="shippingPostcode"]');
          if (shippingAddress && businessAddress) shippingAddress.value = businessAddress.value || "";
          if (shippingAddress2 && businessAddress2) shippingAddress2.value = businessAddress2.value || "";
          if (shippingCity && city) shippingCity.value = city.value || "";
          if (shippingState && state) shippingState.value = state.value || "";
          if (shippingPostcode && postcode) shippingPostcode.value = postcode.value || "";
        }

        if (shippingToggle && shippingBlock) {

          function toggleShipping() {
            var isNo = shippingToggle.value === "no";
            if (isNo) {
              shippingBlock.hidden = false;
              shippingBlock.classList.remove("hidden");
              shippingBlock.querySelectorAll("[name]").forEach(function (input) {
                input.removeAttribute("required");
              });
            } else {
              copyBusinessToShipping();
              shippingBlock.hidden = true;
              shippingBlock.classList.add("hidden");
            }
          }

          shippingToggle.addEventListener("change", toggleShipping);
          toggleShipping();

          ["businessAddress", "businessAddress2", "city", "state", "postcode"].forEach(function (name) {
            var el = form.querySelector('[name="' + name + '"]');
            if (el) {
              el.addEventListener("input", function () {
                if (shippingToggle.value === "yes") copyBusinessToShipping();
              });
              el.addEventListener("change", function () {
                if (shippingToggle.value === "yes") copyBusinessToShipping();
              });
            }
          });

          ["shippingAddress", "shippingAddress2", "shippingCity", "shippingState", "shippingPostcode"].forEach(function (name) {
            var el = form.querySelector('[name="' + name + '"]');
            if (el) {
              el.addEventListener("input", function () {
                if (shippingToggle.value === "yes") {
                  shippingToggle.value = "no";
                  shippingToggle.dispatchEvent(new Event("change", { bubbles: true }));
                }
              });
              el.addEventListener("change", function () {
                if (shippingToggle.value === "yes") {
                  shippingToggle.value = "no";
                  shippingToggle.dispatchEvent(new Event("change", { bubbles: true }));
                }
              });
            }
          });
        }

        setupPhoneByCountry(form, formId);

        // Apply or remove character limits from form settings (dashboard toggle)
        (function applyFormSettingsLimits() {
          var first = form.querySelector('[name="firstName"]');
          var last = form.querySelector('[name="lastName"]');
          var biz = form.querySelector('[name="businessName"]');
          var formIdParam = encodeURIComponent(formId);
          fetch(apiBase + "/api/wholesale/form-settings?formId=" + formIdParam)
            .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
            .then(function (data) {
              if (!data) return;
              if (data.characterLimitsEnabled) {
                var firstMax = typeof data.firstNameMax === "number" ? data.firstNameMax : 12;
                var lastMax = typeof data.lastNameMax === "number" ? data.lastNameMax : 12;
                var bizMax = typeof data.businessNameMax === "number" ? data.businessNameMax : 20;
                if (first) { first.setAttribute("maxlength", String(firstMax)); }
                if (last) { last.setAttribute("maxlength", String(lastMax)); }
                if (biz) { biz.setAttribute("maxlength", String(bizMax)); }
              } else {
                if (first) { first.removeAttribute("maxlength"); }
                if (last) { last.removeAttribute("maxlength"); }
                if (biz) { biz.removeAttribute("maxlength"); }
              }
            })
            .catch(function () {});
        })();

        var hearToggle = form.querySelector("[data-whemb-hear-toggle]");
        var hearOtherWrap = form.querySelector("[data-whemb-hear-other-wrap]");
        if (hearToggle && hearOtherWrap) {
          function toggleHearOther() {
            var isOther = (hearToggle.value || "").trim() === "Other";
            if (isOther) {
              hearOtherWrap.hidden = false;
              hearOtherWrap.classList.remove("hidden");
              var otherInput = hearOtherWrap.querySelector('[name="howDidYouHearOther"]');
              if (otherInput) otherInput.setAttribute("required", "");
            } else {
              hearOtherWrap.hidden = true;
              hearOtherWrap.classList.add("hidden");
              var otherInput = hearOtherWrap.querySelector('[name="howDidYouHearOther"]');
              if (otherInput) {
                otherInput.removeAttribute("required");
                otherInput.value = "";
              }
            }
          }
          hearToggle.addEventListener("change", toggleHearOther);
          toggleHearOther();
        }

        var attachmentInput = form.querySelector("[data-whemb-attachments]");
        var fileHint = form.querySelector("[data-whemb-file-hint]");
        if (attachmentInput && fileHint) {
          function updateFileHint() {
            var files = attachmentInput.files;
            var n = files ? files.length : 0;
            fileHint.textContent = n === 0 ? "No files chosen" : n === 1 ? "1 file chosen" : n + " files chosen";
          }
          attachmentInput.addEventListener("change", updateFileHint);
        }

        if (SECRET_DEBUG_MODE) {
          var firstNameInput = form.querySelector('[name="firstName"]');
          if (firstNameInput) {
            firstNameInput.addEventListener("input", function () {
              if (this.value.trim() === "ADMIN") {
                var countrySelect = form.querySelector('[name="country"]');
                var country = countrySelect ? (countrySelect.value || "").trim() : "";
                var prefill = (country && DEMO_BY_COUNTRY[country]) || (formId === "JADORE_WHOLESALE" ? JADORE_PREFILL : formId === "HADRILL_WHOLESALE" ? HADRILL_PREFILL : null);
                if (prefill) {
                  applyPrefill(form, formId, prefill);
                  var emailEl = form.querySelector('[name="email"]');
                  if (emailEl) emailEl.value = "herosignups+" + Math.floor(Math.random() * 10000000) + "@gmail.com";
                  var hearToggle = form.querySelector("[data-whemb-hear-toggle]");
                  if (hearToggle) hearToggle.dispatchEvent(new Event("change", { bubbles: true }));
                }
              }
            });
          }
        }

        function handleSignupSubmit(e) {
          if (e && typeof e.preventDefault === "function") e.preventDefault();
          if (e && typeof e.stopPropagation === "function") e.stopPropagation();
          if (submissionInFlight || completionHandled) return;
          clearFieldErrors(form);
          if (isFinlandSignup()) {
            updateFinlandGate();
            showMsg("For wholesale registration and orders in Finland, please contact our Finnish distributor, Lifestyle shop JH Oy: info@lifestyleshop.fi · +358 40 7009927 · https://www.lifestyleshop.fi/", true);
            return;
          }

          if (shippingToggle && shippingBlock && shippingToggle.value === "yes") {
            copyBusinessToShipping();
          }

          var nationalInput = form.querySelector("[data-whemb-phone-national]");
          if (nationalInput) nationalInput.dispatchEvent(new Event("input", { bubbles: true }));

          var validation = validateForm(form);
          if (!validation.ok) {
            showMsg("Please fix the errors below and try again.", true);
            showFieldErrors(form, validation.fields);
            return;
          }

          var payload = formToPayload(form, formId);
          if (payload.shippingSameAsBusiness === false) {
            var shipAddr = form.querySelector('[name="shippingAddress"]');
            var shipCity = form.querySelector('[name="shippingCity"]');
            var shipState = form.querySelector('[name="shippingState"]');
            var shipPost = form.querySelector('[name="shippingPostcode"]');
            if (shipAddr) shipAddr.setAttribute("required", "");
            if (shipCity) shipCity.setAttribute("required", "");
            if (shipState) shipState.setAttribute("required", "");
            if (shipPost) shipPost.setAttribute("required", "");
            validation = validateForm(form);
            if (!validation.ok) {
              showMsg("Please fix the errors below and try again.", true);
              showFieldErrors(form, validation.fields);
              return;
            }
          }

          function precheckExisting(payloadObj) {
            var email = String(payloadObj.email || "").trim().toLowerCase();
            var phone = String(payloadObj.phone || "").trim();
            if (!email) return Promise.resolve({ existing: false });
            var checkUrl = apiBase + "/api/wholesale/check-existing-account?email=" + encodeURIComponent(email) +
              "&formId=" + encodeURIComponent(formId) +
              (phone ? "&phone=" + encodeURIComponent(phone) : "");
            showMsg("Checking existing account…", false);
            return fetch(checkUrl).then(function (r) { return r.json(); });
          }

          submissionInFlight = true;
          submitBtn.disabled = true;
          var payload = formToPayload(form, formId);
          if (applicationVerificationToken) payload.verificationToken = applicationVerificationToken;
          var attachmentInput = form.querySelector("[data-whemb-attachments]");
          var files = attachmentInput && attachmentInput.files ? Array.prototype.slice.call(attachmentInput.files) : [];

          function uploadOne(file) {
            var params = "formId=" + encodeURIComponent(formId) + "&filename=" + encodeURIComponent(file.name || "file");
            return fetch(apiBase + "/api/wholesale/upload?" + params, {
              method: "POST",
              headers: { "Content-Type": file.type || "application/octet-stream" },
              body: file,
            }).then(function (res) {
              return res.json().then(function (data) {
                if (data && data.ok && data.url) return data.url;
                throw new Error(data && data.error ? data.error : "Upload failed");
              });
            });
          }

          function doSignup() {
            showMsg("Sending…", false);
            return fetch(apiBase + "/api/wholesale/signup", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(payload),
            }).then(function (res) {
              return res.text().then(function (text) {
                var data = {};
                try {
                  data = text ? JSON.parse(text) : {};
                } catch (_) {
                  data = { error: "Server returned invalid response.", detail: "Status: " + res.status + " " + (res.statusText || "") };
                }
                if (res.ok && data && data.ok === true) return { ok: true, data: data };
                if (!data || typeof data !== "object") data = { error: "Invalid application response. Please contact support before submitting again." };
                if (!data.error && res.status) data.error = "Request failed (" + res.status + (res.statusText ? " " + res.statusText : "") + ").";
                return { ok: false, data: data };
              });
            });
          }

          function doSignupWithPayload() {
            if (files.length > 0) {
              showMsg("Uploading " + files.length + " file(s)…", false);
              return Promise.all(files.map(uploadOne)).then(function (urls) {
                payload.attachmentUrls = urls;
                return doSignup();
              });
            }
            return doSignup();
          }
          if (applicationVerificationToken) {
            doSignupWithPayload()
            .then(function (result) {
              if (result.ok) {
                completeSignup();
              } else {
                var d = result.data;
                var mainError = d.error || "Something went wrong. Please try again.";
                if (d.detail) mainError = mainError + " " + d.detail;
                showMsg(mainError, true);
                if (d.fields && Object.keys(d.fields).length > 0) showFieldErrors(form, d.fields);
              }
            })
            .catch(function (err) {
              var msg = err && err.message ? err.message : String(err);
              showMsg(msg || "Something went wrong. Please try again.", true);
            })
            .finally(function () { submissionInFlight = false; submitBtn.disabled = completionHandled; });
            return;
          }
          precheckExisting(payload)
            .then(function (precheck) {
              if (precheck && precheck.existing) {
                var fieldErrs = {};
                if (precheck.existingEmail) {
                  fieldErrs.email = "An account with this email already exists. Please sign in.";
                }
                if (precheck.existingPhone) {
                  fieldErrs.phone = "An account with this phone already exists. Please use another number or contact support.";
                }
                showMsg("An account already exists with these details. Please sign in.", true);
                if (Object.keys(fieldErrs).length) showFieldErrors(form, fieldErrs);
                throw new Error("__whemb_existing_block__");
              }
              return doSignupWithPayload();
            })
            .then(function (result) {
              if (result.ok) {
                completeSignup();
              } else {
                var d = result.data;
                var mainError = d.error || "Something went wrong. Please try again.";
                if (d.detail) mainError = mainError + " " + d.detail;
                showMsg(mainError, true);
                if (d.fields && Object.keys(d.fields).length > 0) {
                  showFieldErrors(form, d.fields);
                }
              }
            })
            .catch(function (err) {
              if (err && err.message === "__whemb_existing_block__") return;
              var msg = err && err.message ? err.message : String(err);
              showMsg(msg || "Something went wrong. Please try again.", true);
            })
            .finally(function () {
              submissionInFlight = false;
              submitBtn.disabled = completionHandled;
            });
        }

        if (submitBtn) {
          // Avoid native form submit semantics for this custom form only.
          submitBtn.setAttribute("type", "button");
          submitBtn.addEventListener("click", handleSignupSubmit);
        }

        form.addEventListener("keydown", function (e) {
          if (!e || e.key !== "Enter") return;
          var tag = (e.target && e.target.tagName ? String(e.target.tagName) : "").toUpperCase();
          if (tag === "TEXTAREA") return;
          e.preventDefault();
          if (submitBtn && !submitBtn.disabled) submitBtn.click();
        });

          if (!singleAttempt) startPopulatedCheck(prefillEmail);
        })
        .catch(function (err) {
          if (!singleAttempt && attemptNumber < FORM_FETCH_MAX_ATTEMPTS - 1) {
            setTimeout(function () {
              attempt(attemptNumber + 1, false, prefillEmail);
            }, FORM_FETCH_RETRY_DELAY_MS);
          } else if (!singleAttempt) {
            container.innerHTML = "<p class=\"text-sm text-red-600\">Form could not be loaded. Please refresh the page.</p>";
          }
        });
    }

    function startPopulatedCheck(initialPrefillEmail) {
      var intervalMs = 2000;
      var checkId = setInterval(function () {
        if (!container.isConnected) {
          clearInterval(checkId);
          return;
        }
        var form = container.querySelector("[data-whemb-form]");
        var populated = !!form;
        var visible = isElementVisible(container);
        if (populated && visible) {
          clearInterval(checkId);
          return;
        }
        attempt(0, true, initialPrefillEmail);
      }, intervalMs);
    }

    showEmailStep();
  }

  var mountedCount = 0;
  var loggedNoContainerYet = false;

  function isElementVisible(el) {
    if (!el || !el.isConnected) return false;
    try {
      if (el.offsetParent === null && el.tagName !== "BODY") return false;
      var r = el.getBoundingClientRect();
      return r.height > 0 && r.width > 0;
    } catch (e) {
      return false;
    }
  }

  function run() {
    var containers = document.querySelectorAll("[data-wholesale-embed]");
    for (var i = 0; i < containers.length; i++) {
      var el = containers[i];
      if (!el.isConnected) continue;
      if (el.getAttribute("data-whemb-mounted") === "true") continue;
      var formId = (el.getAttribute("data-form-id") || "").trim() || "HADRILL_WHOLESALE";
      if (formId === "HADRILL_WHOLESALE" || formId === "JADORE_WHOLESALE") {
        el.setAttribute("data-whemb-mounted", "true");
        mountForm(el, formId);
        mountedCount += 1;
      }
    }
  }

  function scheduleAllRuns() {
    run();
    var t = 200;
    while (t <= 8000) { setTimeout(run, t); t += 200; }
    t = 9000;
    while (t <= 600000) { setTimeout(run, t); t += 2000; }
  }

  function startObserver() {
    if (!document.body || window.__wholesaleEmbedObserverStarted) return;
    window.__wholesaleEmbedObserverStarted = true;
    if (typeof MutationObserver === "undefined") return;
    var observer = new MutationObserver(function () {
      run();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Run as soon as we can
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      scheduleAllRuns();
      startObserver();
    });
  } else {
    scheduleAllRuns();
    if (document.body) startObserver();
    else document.addEventListener("DOMContentLoaded", startObserver);
  }
  // Run again on full page load (some themes modify DOM then)
  window.addEventListener("load", run);
})();
